
import React, { Component } from "react";
import { withStyles } from '@material-ui/core/styles'
import classNames from 'classnames';
import { Link, Redirect } from 'react-router-dom';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Divider from '@material-ui/core/Divider';
import MenuIcon from '@material-ui/icons/Menu';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button'

import Test from '../pages/Test';
import Home from '../pages/Home';
import NotFound from '../pages/NotFound';

import Authentication, { isAuthenticated } from '../components/Authentication';


import QADisplay from '../components/QA_Display';
import RollBarDisplay from '../components/RollBar_Display';
import QuickWinDisplay from '../components/QuickWin_Display';
import AssignmentDisplay from '../components/Assignment_Display';
import CustomerDisplay from '../components/Customer_Display';
import * as NA from '../actions/NavbarActions';
import * as DH from '../others/DataHelpers';
import * as CA from '../actions/CustomerActions';
import * as QA from '../actions/QAActions';
import qaStore from '../stores/QAStore';
import customerStore from '../stores/CustomerStore';
import assignmentStore from '../stores/AssignmentStore';
import * as AA from '../actions/AssignmentActions';
import navbarStore from '../stores/NavbarStore';

const drawerWidth = 240;
const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    appFrame: {
        height: '100%',
        overflowX: 'auto',
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        width: '100%',
    },
    appBar: {
        position: 'absolute',
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    'appBarShift-left': {
        marginLeft: drawerWidth,
    },
    'appBarShift-right': {
        marginRight: drawerWidth,
    },
    menuButton: {
        marginLeft: 12,
        marginRight: 20,
    },
    hide: {
        display: 'none',
    },
    drawerPaper: {
        position: 'relative',
        width: drawerWidth,
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        minHeight: '30px',
        // ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing.unit * 0,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    'content-left': {
        marginLeft: -drawerWidth,
    },
    'content-right': {
        marginRight: -drawerWidth,
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    'contentShift-left': {
        marginLeft: 0,
    },
    'contentShift-right': {
        marginRight: 0,
    },
    left: {
        position: 'absolute',
        left: '45px'
    },
    image: {
        height: '2em',
        position: 'absolute',
        left: '10px'
    },
    right: {
        position: 'absolute',
        right: '0px'
    },
    center: {
        textAlign: 'center'
    },
    middle: {
        verticalAlign: 'middle',
        height: 'inherit',
    },
    footer: {
        textAlign: 'right',
        height: '28px',
        padding: '4px'
    },
    quickLink: {
        width: '100%',
        justifyContent: 'left',
    },
    quickLinkText: {
        marginLeft: '15%'
    },
    quickLinkHome: {
        width: '100%',
        justifyContent: 'left',
        fontWeight: 'bold',
    },
    quickLinkContainer: {
        padding: '2px'
    },
    bareLink: {
        textDecoration: 'none'
    }
});

class NavBar extends Component {

    constructor(props) {
        super(props)

        this.getNavbarStore = this.getNavbarStore.bind(this);

        const { version, open, anchor, authentication } = navbarStore.getAll();
        const assign = assignmentStore.getAll();
        const customer = customerStore.getAll();
        const qa = qaStore.getAll();
        this.state = {
            version,
            open,
            anchor,
            authentication,
            refresh: false,
            assignMeta: assign.meta,
            customerMeta: customer.meta,
            qaMeta: qa.meta
        };
    }


    // --- HOOKS ---

    componentDidMount() {
        const authentication = isAuthenticated()
        this.setState({ authentication })
        navbarStore.on('change', this.getNavbarStore);
    };

    componentWillUnmount() {
        navbarStore.removeListener('change', this.getNavbarStore);
    }

    // --- FLUX ---

    getNavbarStore = () => {
        const { open, authentication } = navbarStore.getAll();
        this.setState({
            open,
            authentication
        })
    }

    // --- EVENTS ---

    handleRefresh = (refresh) => (event) => {
        if (refresh) {

            let assignMeta = this.state.assignMeta
            assignMeta.loading = true;
            let qaMeta = this.state.qaMeta
            qaMeta.loading = true;
            let customerMeta = this.state.customerMeta
            customerMeta.loading = true

            CA.updateMeta(customerMeta);
            QA.updateMeta(qaMeta);
            AA.updateMeta(assignMeta);
            NA.refresh();
        } else {
            this.setState({ refresh: false })
        }
    }

    handleDrawerOpen = () => {
        this.setState({ open: true });
    };

    handleDrawerClose = () => {
        this.setState({ open: false });
    };

    handleAuthenticated = (authenticated) => {
        NA.updateAuthentication(authenticated);
    }


    // --- Helpers ---

    refresh = () => {
        return (
            <Button
                onClick={this.handleRefresh(true)}
            >
                <img src="https://s3-us-west-2.amazonaws.com/dj-icons/refresh.svg" alt='' />
            </Button>
        )
    }

    // keywords = [{type: '', label: ''}]

    getQuickLinks = (quickLinks) => {
        const { classes } = this.props
        let customClass, customClassName;
        var test = quickLinks.map((quickLink) => {
            const { id, text } = quickLink;
            let filter = {};
            let url = '/';
            const split = id.split('-');
            const key = split[0];
            url += key;
            const type = split[1];
            customClassName = classes.quickLink;
            customClass = classes.quickLinkText;
            switch (type) {
                case 'home':
                    customClassName = classes.quickLinkHome;
                    customClass = null;
                    break;
                case 'release':
                    filter = { status: 'ANY', release: 'CURRENT', severity: 'ANY', assignment: 'ANY' }
                    break;
                case 'development':
                    filter = { release: 'ANY', status: 'OPEN', assignment: 'ALL', severity: 'ANY' }
                    break;
                case 'assignment':
                    filter = { release: 'ANY', status: 'OPEN', assignment: 'NONE', severity: 'ALL' }
                    break;
                case 'severity':
                    filter = { release: 'ANY', status: 'OPEN', assignment: 'ANY', severity: 'NONE' }
                    break;
                case 'blocked':
                    filter = { release: 'ANY', status: 'BLOCKED', assignment: 'ANY', severity: 'ANY' }
                    break;
                default:
            }
            let params = DH.createUrlParams(filter);
            url += params;
            return (
                <div key={id} className={classes.quickLinkContainer}>
                    <Link to={url} onClick={this.handleDrawerClose} className={classes.bareLink}>
                        <Button
                            className={customClassName}
                            classes={{label: customClass}}
                        >
                            {text}
                        </Button>
                    </Link>
                    <br></br>
                </div>
            )
        })
        return test;
    }

    // --- COMPONENTS ---

    currentComponent = () => {

        const { version } = this.state;
        const { classes, location } = this.props


        switch (location.pathname) {
            case '/test':
                return (
                    <Test></Test>
                )

            case '/qa':
                return (
                    <QADisplay location={location}></QADisplay>
                )

            case '/assignment':
                return (
                    <AssignmentDisplay></AssignmentDisplay>
                )
            case '/customer':
                return (
                    <CustomerDisplay location={location}></CustomerDisplay>
                )
            case '/quickwin':
                return (
                    <QuickWinDisplay location={location}></QuickWinDisplay>
                )
            case '/rollbar':
                return (
                    <RollBarDisplay location={location}></RollBarDisplay>
                )
            case '/login':
                return (
                    <div className={classes.center}>
                        <br /><br /><br /><br/>
                        <h3>Authenticate using GitHub OAuth:</h3><br/><br/>
                        <Authentication {...this.props} local={this.props.local} environment={this.props.environment} handleAuthenticated={this.handleAuthenticated.bind(this)}></Authentication>
                        <br /><br /><br />
                        <p>Note: GitHub will ask for permissions to your private repositories in order to view Deki.</p>
                    </div>
                )
            case '/':
                return (
                    <Home {...this.props} version={version}></Home>
                )
            default:
                return (
                    <NotFound></NotFound>
                )
        }
    }

    // --- RENDER ---

    render() {
        const { classes, location } = this.props;
        const { open, anchor, version, authentication } = this.state;

        if(!(location.pathname.includes('login')) && !(authentication)) {
            return (
                <Redirect
                    to={{
                        pathname: "/login",
                        state: { from: location }
                    }}
                >
                </Redirect>
            )
        }

        const drawer = (
            <Drawer
                variant="persistent"
                anchor={anchor}
                open={open}
                classes={{
                    paper: classes.drawerPaper,
                }}
            >
                <div>
                    <div className={classes.drawerHeader}>
                    <img src='https://s3-us-west-2.amazonaws.com/dj-icons/MT_Logo.png' alt='' className={classes.image}></img> 
                        <IconButton onClick={this.handleDrawerClose}>
                            {/* <ChevronRightIcon /> */}
                            <ChevronLeftIcon />
                        </IconButton>
                    </div>
                    <Divider />

                    <div>
                        {this.getQuickLinks([
                            { id: '-home', text: 'HOME' },
                        ])}
                        <Divider />
                        {this.getQuickLinks([
                            { id: 'customer-home', text: 'CUSTOMER' },
                            { id: 'customer-release', text: 'In Release' },
                            { id: 'customer-development', text: 'In Development' },
                            { id: 'customer-assignment', text: 'Need Assignment' },
                            { id: 'customer-severity', text: 'Need Severity' },
                            { id: 'customer-blocked', text: 'Blocked' },
                        ])}
                        <Divider />
                        {this.getQuickLinks([
                            { id: 'qa-home', text: 'QUALITY ASSURANCE' },
                            { id: 'qa-release', text: 'In Release' },
                            { id: 'qa-development', text: 'In Development' },
                            { id: 'qa-assignment', text: 'Need Assignment' },
                            { id: 'qa-blocked', text: 'Blocked' },
                        ])}
                        <Divider />
                        {this.getQuickLinks([
                            { id: 'quickwin-home', text: 'QUICK-WIN' },
                        ])}
                        <Divider />
                        <Divider />
                        {this.getQuickLinks([
                            { id: 'rollbar-home', text: 'ROLLBAR' },
                        ])}
                        <Divider />
                        {this.getQuickLinks([
                            { id: 'assignment-home', text: 'ASSIGNMENT' },
                        ])}
                        {/* <Divider />
                        {this.getQuickLinks([
                            { id: 'test-home', text: 'TEST' },
                        ])} */}
                        <Divider />
                        <div className={classes.center}>
                            <br/>
                            <Authentication {...this.props} local={this.props.local} handleAuthenticated={this.handleAuthenticated.bind(this)}></Authentication>
                        </div>
                    </div>
                </div>
            </Drawer>
        );

        return (
            <div
                className={classes.appFrame}
            >
                <AppBar
                    className={classNames(classes.appBar, {
                        [classes.appBarShift]: open,
                        [classes[`appBarShift-left`]]: open,
                    })}
                >
                    <Toolbar disableGutters={!open}>
                    
                        <IconButton
                            onClick={this.handleDrawerOpen}
                            className={classNames(classes.menuButton, open && classes.hide)}
                        >
                            <MenuIcon />
                        </IconButton>
                        <div className={classes.right}>
                            {this.refresh()}
                        </div>
                    </Toolbar>
                </AppBar>
                {drawer}
                <main
                    className={classNames(classes.content, classes[`content-left`], {
                        [classes.contentShift]: open,
                        [classes[`contentShift-left`]]: open,
                    })}
                    onClick={this.handleDrawerClose}
                >
                    <div className={classes.drawerHeader} />
                    {this.currentComponent(this.props.location)}
                    <div className={classes.footer}>
                        <img src='https://s3-us-west-2.amazonaws.com/dj-icons/Logo_Red.png' alt='' className={classes.middle}></img>
                        &nbsp;
                        <span className={classes.middle}>
                                Defect Board v{version} 
                        </span>
                    </div>
                </main>
            </div>
        );
    }
}

NavBar.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(NavBar);


// WEBPACK FOOTER //
// ./src/js/pages/NavBar.js